import { render, staticRenderFns } from "./ContractViewGlobal.vue?vue&type=template&id=53921f94"
import script from "./ContractViewGlobal.vue?vue&type=script&lang=js"
export * from "./ContractViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports